import React, { useEffect } from "react";
import { PORTAL_LOGIN_URL, PORTAL_REGISTER_URL, PORTAL_SHOP_URL } from "../../config";
const campaignKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "msclkid"];
const portalOrigins = [PORTAL_LOGIN_URL, PORTAL_REGISTER_URL, PORTAL_SHOP_URL].map(url => safeOrigin(url)).filter((origin): origin is string => Boolean(origin));
function CampaignParamBridge() {
  useEffect(() => {
    const preserveCampaign = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const anchor = target.closest<HTMLAnchorElement>("a[href]");
      if (!anchor) return;
      try {
        const destination = new URL(anchor.href, window.location.href);
        if (!portalOrigins.includes(destination.origin)) return;
        const currentParams = new URLSearchParams(window.location.search);
        campaignKeys.forEach(key => {
          const value = currentParams.get(key);
          if (value && !destination.searchParams.has(key)) destination.searchParams.set(key, value);
        });
        anchor.href = destination.toString();
      } catch {
        // Leave malformed or non-HTTP destinations untouched.
      }
    };
    document.addEventListener("click", preserveCampaign, true);
    return () => document.removeEventListener("click", preserveCampaign, true);
  }, []);
  return null;
}
function safeOrigin(url: string) {
  try {
    return new URL(url, window.location.origin).origin;
  } catch {
    return null;
  }
}
export { CampaignParamBridge };